'use es6';

import { deref, watch, unwatch } from 'atom';
import { Component, forwardRef } from 'react';
import { isResolved } from 'reference-resolvers/utils';
import omit from 'transmute/omit';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { defaultEnumOptionFormatter } from '../defaults/defaultEnumOptionFormatter';
import { Select } from 'foundations-components/transitional/components/Select';
import { TransitionalIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const translateReferenceLabelIfHubSpotDefined = reference => reference.getIn(['referencedObject', 'hubspotDefined']) ? reference.update('label', propertyLabelTranslator) : reference;
const defaultProps = {
  options: [],
  optionFormatter: defaultEnumOptionFormatter
};
const initialState = {
  options: []
};
export class ReferenceInputEnumAll extends Component {
  constructor() {
    super();
    this.handleOptionsChange = options => {
      const {
        filter,
        optionFormatter
      } = this.props;
      if (isResolved(options)) {
        const filteredOptions = filter ? options.filter(filter) : options;
        this.setState({
          options: filteredOptions.map(translateReferenceLabelIfHubSpotDefined).sort((a, b) => a.getIn(['referencedObject', 'displayOrder'], -1) - b.getIn(['referencedObject', 'displayOrder'], -1)).map(optionFormatter).toArray()
        });
      }
    };
    this.state = initialState;
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.configureResolver(this.props);
  }
  componentDidUpdate(prevProps) {
    if (this.props.resolver !== prevProps.resolver) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleOptionsChange);
      }
      this.configureResolver(this.props);
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  configureResolver(props) {
    const {
      resolver
    } = props;
    this.referenceAtom = resolver.all();
    watch(this.referenceAtom, this.handleOptionsChange);
    this.handleOptionsChange(deref(this.referenceAtom));
  }
  getOptions() {
    const {
      options
    } = this.props;
    const {
      options: valueOptions
    } = this.state;
    return options.concat(valueOptions).map(option => Object.assign({}, option, {
      icon: option.icon && (() => /*#__PURE__*/_jsx(TransitionalIcon, {
        name: option.icon
      })),
      // HACK: We can't support icon colors, there's no color > token mapping
      iconColor: undefined
    }));
  }
  render() {
    const SelectComponent = this.props.SelectComponent || Select;
    const transferrableProps = omit(['innerRef', 'onCancel', 'onSecondaryChange', 'SelectComponent'], this.props);
    return /*#__PURE__*/_jsx(SelectComponent, Object.assign({}, transferrableProps, {
      anchorType: "button",
      inputRef: this.props.inputRef,
      ref: this.props.innerRef,
      options: this.getOptions()
    }));
  }
}
ReferenceInputEnumAll.defaultProps = defaultProps;
export default /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(ReferenceInputEnumAll, Object.assign({}, props, {
  innerRef: ref
})));